/**
 * @file useContentHeight.ts
 * @description Custom hook for measuring the height of rendered content.
 * Used to dynamically set the height of textarea elements to match their content.
 * Provides a consistent user experience between viewing and editing modes.
 */

import { useEffect, useRef, useState } from "react";

export const useContentHeight = (content: string, className: string) => {
  const [height, setHeight] = useState<number | undefined>(undefined);
  const measureRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (measureRef.current) {
      const newHeight = measureRef.current.clientHeight;
      setHeight(newHeight);
    }
  }, [content]);

  return { height, measureRef, className };
};
